var _rect, _rect2, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 284.376,
    width: 437.612,
    height: 183.437,
    rx: 30.5729,
    fill: "#231942"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330.531,
    y: 185.464,
    width: 31.1724,
    height: 124.689,
    rx: 15.5862,
    fill: "#231942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.738 172.775C379.964 171.69 385.113 164.758 381.706 158.295C379.265 153.662 375.908 149.512 371.79 146.115C364.219 139.869 354.601 136.6 344.762 136.93C334.923 137.26 325.548 141.165 318.419 147.903C314.539 151.57 311.471 155.938 309.35 160.727C306.392 167.403 311.994 173.967 319.271 174.565L322.519 174.832C327.989 175.282 332.65 170.664 336.639 166.894V166.894C339.079 164.588 342.287 163.252 345.653 163.139C349.02 163.026 352.311 164.145 354.901 166.282V166.282C359.138 169.777 364.102 174.072 369.534 173.256L372.738 172.775Z",
    fill: "#231942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.661 142.034C415.665 138.648 420.815 127.308 414.324 118.978C408.764 111.843 401.835 105.599 393.812 100.564C379.973 91.8783 363.532 87.2003 346.676 87.1518C329.82 87.1033 313.346 91.6866 299.446 100.292C291.387 105.282 284.414 111.486 278.804 118.589C272.257 126.878 277.335 138.254 287.321 141.699V141.699C296.385 144.826 306.153 139.989 313.121 133.402C315.308 131.334 317.737 129.465 320.376 127.831C328.082 123.06 337.214 120.52 346.558 120.547C355.902 120.574 365.016 123.167 372.687 127.981C375.305 129.624 377.712 131.499 379.878 133.57C386.817 140.204 396.568 145.111 405.661 142.034V142.034Z",
    fill: "#FFB35A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.175 103.79C449.479 98.3924 452.652 86.3004 445.746 78.0552C435.483 65.8033 422.919 55.5137 408.674 47.7782C388.626 36.8906 365.978 31.458 343.072 32.0424C320.167 32.6268 297.836 39.207 278.392 51.1021C264.58 59.5512 252.581 70.4636 242.982 83.2175C236.513 91.8122 240.311 103.723 249.881 108.636V108.636C259.244 113.442 270.591 109.661 277.411 101.646C283.499 94.4907 290.73 88.297 298.859 83.324C312.453 75.0081 328.064 70.4079 344.078 69.9993C360.091 69.5907 375.925 73.3887 389.94 81.0002C398.338 85.5605 405.9 91.3904 412.366 98.2418C419.578 105.884 431.086 109.063 440.175 103.79V103.79Z",
    fill: "#231942"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.537,
    cy: 375.795,
    rx: 25.1777,
    ry: 24.8779,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.67,
    cy: 375.795,
    rx: 25.1777,
    ry: 24.8779,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.81,
    cy: 375.795,
    rx: 25.1777,
    ry: 24.8779,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 328.125,
    y: 346.122,
    width: 86.9229,
    height: 59.3474,
    rx: 11.3899,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperators);
export default __webpack_public_path__ + "static/media/operators.fe85a0e917dafca0abc894a16bdf6b22.svg";
export { ForwardRef as ReactComponent };